const isValid = (token?: string): boolean => {
  return Boolean(token && token !== 'undefined')
}

export const Tokens = {
  isValid,
}
